import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SessionExpiredModal } from './SessionExpiredModal';

/**
 * Handles global auth events and navigation.
 * Must be rendered inside Router context.
 */
export const AuthEventHandler: React.FC = () => {
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const navigate = useNavigate();

  // Listen for auth events from httpClient and authStore
  useEffect(() => {
    const handleRedirectToLogin = () => {
      navigate('/login');
    };

    const handleSessionExpired = () => {
      // If the user is already on the login page (e.g. demo SM session expired
      // while the app was navigating there) skip the modal — they can sign in
      // directly from the page they are already on.
      if (window.location.pathname === '/login') return;
      setShowSessionExpired(true);
    };

    window.addEventListener('auth:redirect-to-login', handleRedirectToLogin);
    window.addEventListener('auth:session-expired', handleSessionExpired);

    return () => {
      window.removeEventListener('auth:redirect-to-login', handleRedirectToLogin);
      window.removeEventListener('auth:session-expired', handleSessionExpired);
    };
  }, [navigate]);

  const handleSessionExpiredConfirm = () => {
    setShowSessionExpired(false);
    navigate('/login');
  };

  return <SessionExpiredModal open={showSessionExpired} onConfirm={handleSessionExpiredConfirm} />;
};
